import api from "./api";

export const uploadPhoto = async (file, onUploadProgress = () => { }) => {
    return await api.post("/files", { file }, {
        onUploadProgress,
        // headers: {
        //     'Content-Type': 'multipart/form-data'
        // }
    });
};
